"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.base32ToInt = exports.intToBase32 = exports.assertLatLngIsValid = exports.assertLongitudeIsValid = exports.assertLatitudeIsValid = exports.assertBitDepthIsValid = exports.assertBase32HashLengthIsValid = exports.compare = void 0;
var constants_1 = require("./constants");
function compare(a, b) {
    return a - b;
}
exports.compare = compare;
function assertBase32HashLengthIsValid(length) {
    var _a = [constants_1.BASE32_HASH_MIN_LENGTH, constants_1.BASE32_HASH_MAX_LENGTH], min = _a[0], max = _a[1];
    if (length < min || length > max) {
        throw new RangeError("Number of chars must be between ".concat(min, " and ").concat(max));
    }
}
exports.assertBase32HashLengthIsValid = assertBase32HashLengthIsValid;
function assertBitDepthIsValid(bitDepth) {
    var _a = [constants_1.MIN_BIT_DEPTH, constants_1.MAX_BIT_DEPTH], min = _a[0], max = _a[1];
    if (bitDepth < min || bitDepth > max) {
        throw new RangeError("Bit depth must be between ".concat(min, " and ").concat(max));
    }
}
exports.assertBitDepthIsValid = assertBitDepthIsValid;
function assertLatitudeIsValid(lat) {
    var _a = [-constants_1.LATITUDE_MAX_VALUE, constants_1.LATITUDE_MAX_VALUE], min = _a[0], max = _a[1];
    if (lat < min || lat > max) {
        throw new RangeError("Latitude must be between ".concat(min, " and ").concat(max));
    }
}
exports.assertLatitudeIsValid = assertLatitudeIsValid;
function assertLongitudeIsValid(lng) {
    var _a = [-constants_1.LONGITUDE_MAX_VALUE, constants_1.LONGITUDE_MAX_VALUE], min = _a[0], max = _a[1];
    if (lng < min || lng > max) {
        throw new RangeError("Longitude must be between ".concat(min, " and ").concat(max));
    }
}
exports.assertLongitudeIsValid = assertLongitudeIsValid;
function assertLatLngIsValid(lat, lng) {
    assertLatitudeIsValid(lat);
    assertLongitudeIsValid(lng);
}
exports.assertLatLngIsValid = assertLatLngIsValid;
function intToBase32(intValue, length) {
    var hash = '';
    var prefix = intValue;
    for (var i = 0; i < length; i++) {
        var code = prefix % 32;
        hash = constants_1.BASE32_DIGITS[code] + hash;
        prefix = Math.floor(prefix / 32);
    }
    return hash;
}
exports.intToBase32 = intToBase32;
function base32ToInt(base32Value) {
    var value = 0;
    var digits = Array.from(base32Value).reverse();
    for (var i = 0; i < digits.length; i++) {
        var code = constants_1.BASE32_DIGITS_MAP.get(digits[i]);
        if (code === undefined) {
            throw new RangeError("Unknown digit: ".concat(digits[i]));
        }
        value += code * Math.pow(32, i);
    }
    return value;
}
exports.base32ToInt = base32ToInt;
